import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    liabs: null
  },
  getters: {
    LIABS: state => {
      return state.liabs;
    }
  },
  mutations: {
    SET_LIABS: (state, payload) => {
      state.liabs = payload;
    },
    ADD_LIABS: (state, payload) => {
      state.liabs.push(payload);
    }
  },
  actions: {
    GET_LIABS: async (context, payload) => {
      let { data } = await Axios.get("http://yourwebsite.com/api/liabs");
      context.commit("SET_liabs", data);
    },
    SAVE_LIABS: async (context, payload) => {
      let { data } = await Axios.post("http://yourwebsite.com/api/liabs");
      context.commit("ADD_TODO", payload);
    }
  }
});
